module.exports = __webpack_public_path__ + "static/media/floor-01.5da961db.png";